import * as TP from '../subscriptionTypes';

import { gql } from '@apollo/client';
export type RouteVendorFinancialStatusEventPayloadFragment = (
  { readonly __typename?: 'RouteVendorFinancialStatusEvent' }
  & Pick<TP.RouteVendorFinancialStatusEvent, 'id' | 'financialStatus' | 'type'>
  & { vendorIdString: TP.RouteVendorFinancialStatusEvent['vendorId'] }
);

export const RouteVendorFinancialStatusEventPayloadFragmentDoc = gql`
    fragment RouteVendorFinancialStatusEventPayload on RouteVendorFinancialStatusEvent {
  id
  vendorIdString: vendorId
  financialStatus
  type
}
    `;